import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-app-upload-file',
    templateUrl: './app-upload-file.component.html',
    styleUrls: ['./app-upload-file.component.css'],
    standalone: false
})
export class AppUploadFileComponent implements OnInit {

  constructor() {}

  ngOnInit(){}
  
}
